/* eslint-disable no-undef */
export default class ConfigService {
  static STRIPE_PROD_PUB_KEY = process.env.REACT_APP_STRIPE_PROD_PUB_KEY;
  static STRIPE_DEV_PUB_KEY = process.env.REACT_APP_STRIPE_DEV_PUB_KEY;
  static STRIPE_MX_PROD_PUB_KEY = process.env.REACT_APP_STRIPE_MX_PROD_PUB_KEY;
  static STRIPE_MX_DEV_PUB_KEY = process.env.REACT_APP_STRIPE_MX_DEV_PUB_KEY;
  static SRPAGO_PROD_PUB_KEY = process.env.REACT_APP_SRPAGO_PROD_PUB_KEY;
  static SRPAGO_PROD_LIVE_MODE = process.env.REACT_APP_SRPAGO_PROD_LIVE_MODE === 'true';
  static SRPAGO_DEV_PUB_KEY = process.env.REACT_APP_SRPAGO_DEV_PUB_KEY;
  static SRPAGO_DEV_LIVE_MODE = process.env.REACT_APP_SRPAGO_DEV_LIVE_MODE === 'true';
  static BASE_URL = process.env.REACT_APP_BASE_URL;
  static GOOGLE_MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY;
}
